import React, { Component } from "react";
import _ from "lodash";
import { Button, Modal, FormControl, FormGroup } from "react-bootstrap";
import { NavLink } from "react-router-dom";
import TimeStamp from "react-timestamp";
import * as reactDeviceDetect from "react-device-detect";
import { fire, auth } from "../../firebase/index";
import { customLog } from "../../variables/Variables";
import "../../assets/css/maincss.css";
import "../../assets/css/header.css";
import LocalizedStrings from "react-localization";
// Icons
import accountManagement from "../../assets/img/AccountManagement.png";
import lockAccess from "../../assets/img/LockAccess.png";
import loginRequest from "../../assets/img/LoginRequest.png";
import notificationStatus from "../../assets/img/notificationStatus.png";
import authorizeIMG from "../../assets/img/Authorize.png";
//import localization
//Localization codes
let localizationStrings = new LocalizedStrings({
  en: {
    PopupHeader: "Redemption Plan Expiring",
    PopupText1: "Hi, ",
    PopupText2_1:
      "A friendly reminder that your Intelligent Access Management System (IAMS) redemption plan is about to ",
    PopupText2_2: "expire",
    PopupText2_3: " on ",
    PopupText2_4: ".",
    PopupText3:
      "If you want to continue using our system, you can renew your redemption plan by clicking the button below:",
    PopupText4_1:
      "If you have any questions or need help regarding the renewal process, please contact us at ",
    PopupText4_2: "support@egeetouch.com",
    PopupText4_3: ".",
    PopupButton: "Renew your plan",
    PopupConfirmBtn: "I understand",
    showToday: " Don't show again today",
  },
  ja: {
    PopupHeader: "お申込みプランの有効期限が過ぎています。",
    PopupText1: "様",
    PopupText2_1:
      "インテリジェントアクセス管理システム（IAMS）の無料トライ期間が終了し、",
    PopupText2_2: "expire",
    PopupText2_3: "に",
    PopupText2_4: "が開始されることをお知らせします。",
    PopupText3:
      "インテリジェントアクセス管理システムを継続利用される場合は、下のボタンをクリックしてご利用プランを更新してください。",
    PopupText4_1: "ご質問は",
    PopupText4_2: "support@egeetouch.com",
    PopupText4_3: "へメールにてご連絡下さい。",
    PopupButton: "プランを更新します。",
    PopupConfirmBtn: "内容を確認しました",
    showToday: " 今後は表示しない",
  },
  es: {
    PopupHeader: "Plan de Redención a Punto de Expirar",
    PopupText1: "Hola, ",
    PopupText2_1:
      "Un recordatorio amistoso de que tu plan de redención del Sistema de Gestión de Acceso Inteligente (IAMS) está a punto de ",
    PopupText2_2: "expirar",
    PopupText2_3: " el ",
    PopupText2_4: ".",
    PopupText3:
      "Si deseas continuar usando nuestro sistema, puedes renovar tu plan de redención haciendo clic en el botón de abajo:",
    PopupText4_1:
      "Si tienes alguna pregunta o necesitas ayuda con respecto al proceso de renovación, por favor contáctanos en ",
    PopupText4_2: "support@egeetouch.com",
    PopupText4_3: ".",
    PopupButton: "Renovar tu plan",
    PopupConfirmBtn: "Entiendo",
    showToday: " No mostrar de nuevo hoy",
  },
});

class RedemptionEndingPopup extends Component {
  constructor(props) {
    super(props);

    this.handlePopupClose = this.handlePopupClose.bind(this);
    this.handlePopupCloseBtn = this.handlePopupCloseBtn.bind(this);
    this.handleChange = this.handleChange.bind(this);

    this.state = {
      redeemedEndTime: "",
      showPopup: false,
      currentLanguage: "en",
    };
  }

  async componentWillMount() {
    //! FOR LANGUAGE
    if (auth.currentUser !== null) {
      fire
        .database()
        .ref("userSettings")
        .child(auth.currentUser.uid) // get uid from auth person object
        .child("language")
        .on("value", this._langCb = (snapshot) => {
          this.setState({
            currentLanguage: snapshot.val(),
          });
        });

      fire
        .database()
        .ref("groupAccounts")
        .child(auth.currentUser.uid)
        .once("value")
        .then((snapshot) => {
          if (snapshot.exists()) {
            let userDetails = snapshot.val();
            if (userDetails.payment.currentPaymentType === "REDEMPTION") {
              this.setState({
                redeemedEndTime: userDetails.payment.endedOn,
              });

              fire
                .database()
                .ref("groupAccounts")
                .child(auth.currentUser.uid)
                .child("dashboardNotification")
                .once("value")
                .then((snapshot) => {
                  if (snapshot.exists()) {
                    if (
                      userDetails.dashboardNotification.redemption != null &&
                      userDetails.dashboardNotification.redemption != undefined
                    ) {
                      let isExpiring =
                        userDetails.dashboardNotification.redemption.expiring;
                      let showToday =
                        userDetails.dashboardNotification.redemption.showToday;

                      if (isExpiring === false || showToday === false) {
                        this.setState({
                          showPopup: false,
                        });
                      } else {
                        this.setState({
                          showPopup: true,
                        });
                      }
                    } else {
                      this.setState({
                        showPopup: false,
                      });
                    }
                  }
                });
            }
          }
        });

      fire
        .database()
        .ref("registeredIndustrialUsersOnPlatform/" + auth.currentUser.uid)
        .once("value")
        .then((snapshot) => {
          if (snapshot.exists()) {
            let userDetails = snapshot.val();
            this.setState({
              userName: userDetails.name,
            });
          }
        });
    }
  }

  handlePopupClose() {
    this.setState({
      showPopup: false,
    });
  }

  handlePopupCloseBtn() {
    if (this.state.checked) {
      fire
        .database()
        .ref("groupAccounts/")
        .child(auth.currentUser.uid)
        .child("dashboardNotification")
        .child("redemption")
        .once("value")
        .then((snapshot) => {
          if (snapshot.exists()) {
            fire
              .database()
              .ref("groupAccounts/")
              .child(auth.currentUser.uid)
              .child("dashboardNotification")
              .child("redemption")
              .update({
                showToday: false,
              });
          } else {
            fire
              .database()
              .ref("groupAccounts/")
              .child(auth.currentUser.uid)
              .child("dashboardNotification")
              .child("redemption")
              .set({
                showToday: false,
              });
          }
        });
    }

    this.setState({
      showPopup: false,
    });
  }

  handleChange(e) {
    let isChecked = e.target.checked;

    this.setState({
      checked: isChecked,
    });
  }

  dateTimeFormat(time) {
    if (localizationStrings.getLanguage() === "ja") {
      customLog(
        new Intl.DateTimeFormat("ja-JP", { era: "long" }).format(time * 1000)
      );
      customLog(
        new Intl.DateTimeFormat("ja-JP", {
          hour: "2-digit",
          minute: "2-digit",
        }).format(time * 1000)
      );
      customLog(Date.now());
      var japanDate = new Intl.DateTimeFormat("ja-JP", {
        year: "numeric",
        month: "long",
        day: "numeric",
      }).format(time * 1000);
      var japanTime = new Intl.DateTimeFormat("ja-JP", {
        hour: "2-digit",
        minute: "2-digit",
      }).format(time * 1000);
      return japanDate + japanTime;
    } else {
      // customLog(new Intl.DateTimeFormat('en-US', { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit' }).format(time));
      return <TimeStamp time={time} format="full" includeDay />;
    }
  }

  componentWillUnmount() {
    if (auth.currentUser !== null && this._langCb) {
      fire
        .database()
        .ref("userSettings")
        .child(auth.currentUser.uid)
        .child("language")
        .off("value", this._langCb);
    }
  }

  render() {
    //! FOR LANGUAGE SETTING
    if (this.state.currentLanguage === "en") {
      localizationStrings.setLanguage("en");
    } else if (this.state.currentLanguage === "ja") {
      localizationStrings.setLanguage("ja");
    } else if (this.state.currentLanguage === "es") {
      localizationStrings.setLanguage("es");
    }

    return (
      <div>
        <Modal
          show={this.state.showPopup}
          onHide={this.handlePopupClose}
          dialogClassName="modal-50w"
          style={{ display: "flex", justifyContent: "center" }}
        >
          <Modal.Header closeButton style={{ border: "none" }}>
            <Modal.Title
              style={{
                textAlign: "center",
                fontSize: "30px",
                marginTop: "10px",
                color: "#FF2121",
              }}
            >
              {localizationStrings.PopupHeader}
            </Modal.Title>
          </Modal.Header>

          <Modal.Body>
            <p
              className="lightFont"
              style={{ width: "90%", textAlign: "left" }}
            >
              <strong>
                {this.state.currentLanguage === "en"
                  ? localizationStrings.PopupText1 + this.state.userName
                  : this.state.userName + localizationStrings.PopupText1}
              </strong>
            </p>
            <br />
            <p
              className="lightFont"
              style={{ width: "90%", textAlign: "left" }}
            >
              {localizationStrings.PopupText2_1}
              <strong style={{ color: "#FF2121" }}>
                {localizationStrings.PopupText2_2}
              </strong>
              {localizationStrings.PopupText2_3}
              <strong>{this.dateTimeFormat(this.state.redeemedEndTime)}</strong>
              {localizationStrings.PopupText2_4}
            </p>
            <br />
            <div
              style={{
                width: "100%",
                display: "flex",
                justifyContent: "center",
              }}
            >
              <div
                style={{ width: "80%", borderBottom: "1px solid #DDDCDC" }}
              ></div>
            </div>
            <br />
            <p
              className="lightFont"
              style={{ width: "80%", textAlign: "justify" }}
            >
              {localizationStrings.PopupText3}
            </p>
            <br />
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                width: "90%",
                margin: "auto",
                padding: "auto",
              }}
            >
              <NavLink
                to="/plans"
                className="nav-link"
                onClick={this.handlePopupClose}
                style={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                <button
                  className="boldFont"
                  style={{
                    backgroundColor: "#25A422",
                    color: "white",
                    border: "none",
                    height: "50px",
                    width: "35%",
                    borderRadius: "3px",
                  }}
                >
                  <p
                    style={{
                      margin: "auto",
                      padding: "auto",
                      fontSize: "18px",
                    }}
                  >
                    {localizationStrings.PopupButton}
                  </p>
                </button>
              </NavLink>
            </div>
            {/* <br />
            <br />
            <p className="lightFont" style={{width: "80%", textAlign: "justify"}}>{"Do note that you will not be able to use the Intelligent Access Management System (IAMS) if your redemption plan has expired."}</p> */}
            <br />
            <div
              style={{
                width: "100%",
                display: "flex",
                justifyContent: "center",
              }}
            >
              <div
                style={{ width: "80%", borderBottom: "1px solid #DDDCDC" }}
              ></div>
            </div>
            <br />
            <p
              className="lightFont"
              style={{ width: "90%", textAlign: "left" }}
            >
              {localizationStrings.PopupText4_1}
              <span style={{ color: "#369AF6", textDecoration: "underline" }}>
                <a href="mailto: support@egeetouch.com">
                  {localizationStrings.PopupText4_2}
                </a>
              </span>
              {localizationStrings.PopupText4_3}
            </p>
            <br />
            <br />
            <div
              style={{
                width: "100%",
                display: "flex",
                justifyContent: "center",
                padding: "auto",
                margin: "auto",
              }}
            >
              <div>
                <div>
                  <input
                    type="checkbox"
                    onChange={(e) => this.handleChange(e)}
                  />{" "}
                  {localizationStrings.showToday}
                </div>
                <div style={{ height: "5px" }}></div>
                <button
                  className="boldFont"
                  style={{
                    backgroundColor: "#59A9F3",
                    color: "white",
                    border: "none",
                    height: "40px",
                    width: "200px",
                    borderRadius: "5px",
                  }}
                  onClick={this.handlePopupCloseBtn}
                >
                  <p style={{ margin: "auto", padding: "auto" }}>
                    {localizationStrings.PopupConfirmBtn}
                  </p>
                </button>
              </div>
            </div>
            <br />
          </Modal.Body>
        </Modal>
      </div>
    );
  }
}

export default RedemptionEndingPopup;
